


















import {Component, Prop, Vue} from 'vue-property-decorator'
import IconCustom from '@/components/lib/IconCustom.vue'

@Component({
  components: {
    IconCustom
  }
})
export default class DropdownCommon extends Vue {
  @Prop() readonly title?: string
  @Prop() readonly footer?: string
}
